module.exports = __webpack_public_path__ + "static/media/logo.0ef3bf43.png";